import * as React from "react";
import { useState } from "react";
import { ButtonToolbar, DeleteMenuItem, MenuItem } from "components/bootstrap";
import { ConfirmDialog, IfPermitted } from "components/common";
import useSelectedEntities from "components/common/EntityDataTable/hooks/useSelectedEntities";
import MoreActions from "components/common/EntityDataTable/MoreActions";
import { useTableFetchContext } from "components/common/PaginatedEntityTable";
import UserNotification from "util/UserNotification";
import BlockingReferencesDialog from "./BlockingReferencesDialog";
import EditCredentialsModal from "./EditCredentialsModal";
import useDeleteRepository from "./hooks/useDeleteRepository";
import { CREDENTIAL_BEARING_TYPES } from "./types";
const RepositoryActions = ({ repository }) => {
  const { deselectEntity } = useSelectedEntities();
  const { refetch } = useTableFetchContext();
  const { onDeleteRepository } = useDeleteRepository();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [showEditCredentials, setShowEditCredentials] = useState(false);
  const [blockingReferences, setBlockingReferences] = useState(null);
  const supportsCredentials = CREDENTIAL_BEARING_TYPES.includes(repository.type);
  const handleDelete = () => {
    setShowDeleteDialog(false);
    onDeleteRepository(repository.name).then(() => {
      deselectEntity(repository.id);
      refetch();
    }).catch((error) => {
      var _a, _b;
      const body = (_a = error == null ? void 0 : error.additional) == null ? void 0 : _a.body;
      if ((error == null ? void 0 : error.status) === 400 && (body == null ? void 0 : body.blocking_references)) {
        setBlockingReferences(body.blocking_references);
      } else {
        UserNotification.error(
          `Deleting repository "${repository.name}" failed: ${(_b = body == null ? void 0 : body.message) != null ? _b : error}`,
          "Could not delete repository"
        );
      }
    });
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, showDeleteDialog && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: showDeleteDialog,
      title: `Delete repository "${repository.name}"`,
      onCancel: () => setShowDeleteDialog(false),
      onConfirm: handleDelete
    },
    /* @__PURE__ */ React.createElement("p", null, "You are about to delete the repository ", /* @__PURE__ */ React.createElement("strong", null, repository.name), " together with its stored credentials. This action cannot be undone.")
  ), blockingReferences && /* @__PURE__ */ React.createElement(
    BlockingReferencesDialog,
    {
      repositoryName: repository.name,
      blockingReferences,
      onClose: () => setBlockingReferences(null)
    }
  ), showEditCredentials && /* @__PURE__ */ React.createElement(EditCredentialsModal, { repositoryName: repository.name, onClose: () => setShowEditCredentials(false) }), /* @__PURE__ */ React.createElement(
    IfPermitted,
    {
      permissions: supportsCredentials ? ["indexsets:edit", "indexsets:delete"] : ["indexsets:delete"],
      anyPermissions: true
    },
    /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(MoreActions, null, supportsCredentials && /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "indexsets:edit" }, /* @__PURE__ */ React.createElement(MenuItem, { onSelect: () => setShowEditCredentials(true) }, "Edit credentials")), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "indexsets:delete" }, /* @__PURE__ */ React.createElement(DeleteMenuItem, { onSelect: () => setShowDeleteDialog(true) }))))
  ));
};
export default RepositoryActions;
